const GIPHY_API_KEY = "tVaJe9QRTL6VZp9xhBkogbNWFTI9hYnJ";
const GIPHY_URL = "https://api.giphy.com/v1/gifs/";
const GIPHY_DEFAULT_CONFIG = {
  LIMIT: 18,
  OFFSET: 0,
  RATING: "G",
  LANG: "en"
};

export { GIPHY_API_KEY, GIPHY_URL, GIPHY_DEFAULT_CONFIG };
